import React, { useEffect, useState } from 'react';
import axios from 'axios';
import useInterval from '@use-it/interval';
import { setVideoPlayerPlaying } from '../actions'
import { useDispatch, useSelector } from 'react-redux'

export default function KavedoIvsPlayer({ videoRoom, streamSource, entranceRepeatTime, ...props }) {

  return <div className="alert alert-danger">Player not supported anymore</div>
  
  const entranceUrl = props.entranceUrl
  const streamKey = props.streamKey
  const videoPlayerPlaying = useSelector(state => state.videoPlayerPlaying)

  const dispatch = useDispatch()

  const disposePlayer = () => {
    if(window.vjsplayer && window.vjsplayer[0]) {
      console.log("dispose", window.vjsplayer[0])
      window.vjsplayer[0].dispose()
      window.vjsplayer.shift()
      console.log("window.timerk[0]", window.timerk[0])
      clearInterval(window.timerk[0])
    }
    dispatch(setVideoPlayerPlaying(false))
  }

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//flave.kavedo.com/ivs/kavedo_ivs_player1_nores.js';
    script.async = true;

    document.body.appendChild(script);

    script.onload = () => {
      initKavedo();
      if(props.onPlayerLoad) {
        props.onPlayerLoad.call()
      }
    }
    
    return disposePlayer
      
  }, [streamSource])

  useInterval(() => {
    if(window.vjsplayer && window.vjsplayer.length == 1 && window.vjsplayer[0] != null && !window.vjsplayer[0].paused()) {
      if(!videoPlayerPlaying){
        dispatch(setVideoPlayerPlaying(true))
      }
      console.warn("playing")
    } else {
      if(videoPlayerPlaying){
        dispatch(setVideoPlayerPlaying(false))
      }
      console.warn("Not playing")
    }
  }, 3000);

  return (
      <div className="flave-video-container">
      <div
        onClick={props.onPlayerClick}
        className="kavedo_player_container"
        data-kavedo={streamSource}
        style={{width: "100%", backgroundColor: "black", minHeight: "30px"}}
      />
      {props.renderCustomContent != "false" && 
        <>
          {props.children}
        </>
      }
      </div>
  )
}
